export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [8,[2]],
		"/(app)/administration": [29,[2]],
		"/(app)/admin": [9,[2,3]],
		"/(app)/admin/analytics": [10,[2,3]],
		"/(app)/admin/analytics/[tab]": [11,[2,3]],
		"/(app)/admin/audit-trail": [12,[2,3]],
		"/(app)/admin/audit-trail/[id]": [13,[2,3]],
		"/(app)/admin/dashboard": [14,[2,3]],
		"/(app)/admin/documents": [15,[2,3]],
		"/(app)/admin/evaluations": [18,[2,3]],
		"/(app)/admin/evaluations/[tab]": [19,[2,3]],
		"/(app)/admin/evaluation": [16,[2,3]],
		"/(app)/admin/evaluation/[id]": [17,[2,3]],
		"/(app)/admin/functions": [20,[2,3]],
		"/(app)/admin/functions/create": [21,[2,3]],
		"/(app)/admin/functions/edit": [22,[2,3]],
		"/(app)/admin/hitl": [23,[2,3]],
		"/(app)/admin/hitl/[id]": [24,[2,3]],
		"/(app)/admin/settings": [25,[2,3]],
		"/(app)/admin/settings/[tab]": [26,[2,3]],
		"/(app)/admin/users": [27,[2,3]],
		"/(app)/admin/users/[tab]": [28,[2,3]],
		"/(app)/audit-log": [30,[2]],
		"/auth": [71],
		"/(app)/automations": [31,[2]],
		"/(app)/automations/[id]": [32,[2]],
		"/(app)/calendar": [34,[2]],
		"/(app)/channels/[id]": [35,[2]],
		"/(app)/conversation-history": [36,[2]],
		"/(app)/c/[id]": [33,[2]],
		"/(app)/data-analytics": [37,[2]],
		"/(app)/document-generation": [38,[2]],
		"/error": [72],
		"/(app)/home": [39,[2,4]],
		"/(app)/knowledge-base": [40,[2]],
		"/(app)/knowledge-base/upload": [41,[2]],
		"/(app)/notes": [42,[2,5]],
		"/(app)/notes/new": [43,[2,5]],
		"/(app)/notes/[id]": [44,[2,5]],
		"/(app)/notifications": [45,[2]],
		"/(app)/performance": [46,[2]],
		"/(app)/playground": [47,[2,6]],
		"/(app)/playground/completions": [48,[2,6]],
		"/(app)/playground/images": [49,[2,6]],
		"/(app)/profile": [50,[2]],
		"/s/[id]": [73],
		"/(app)/user-guide": [51,[2]],
		"/watch": [74],
		"/(app)/welcome": [52,[2]],
		"/(app)/workspace": [53,[2,7]],
		"/(app)/workspace/documents": [54,[2,7]],
		"/(app)/workspace/functions/create": [55,[2,7]],
		"/(app)/workspace/knowledge": [56,[2,7]],
		"/(app)/workspace/knowledge/create": [57,[2,7]],
		"/(app)/workspace/knowledge/[id]": [58,[2,7]],
		"/(app)/workspace/models": [59,[2,7]],
		"/(app)/workspace/models/create": [60,[2,7]],
		"/(app)/workspace/models/edit": [61,[2,7]],
		"/(app)/workspace/prompts": [62,[2,7]],
		"/(app)/workspace/prompts/create": [63,[2,7]],
		"/(app)/workspace/prompts/[id]": [64,[2,7]],
		"/(app)/workspace/skills": [65,[2,7]],
		"/(app)/workspace/skills/create": [66,[2,7]],
		"/(app)/workspace/skills/edit": [67,[2,7]],
		"/(app)/workspace/tools": [68,[2,7]],
		"/(app)/workspace/tools/create": [69,[2,7]],
		"/(app)/workspace/tools/edit": [70,[2,7]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';